<ngx-loading-bar color="#c00053" height="4px"> </ngx-loading-bar>

<router-outlet></router-outlet>
